import { useState, useEffect, useCallback } from 'react';
import { registerImageUpdateCallback, getProfileImageSrc } from '../config/defaultImages';

export const useProfileImage = (user) => {
  const [imageKey, setImageKey] = useState(Date.now());
  const [imageSrc, setImageSrc] = useState('');

  // Memoizar la función de actualización
  const updateImage = useCallback(() => {
    const newKey = Date.now();
    setImageKey(newKey);
    setImageSrc(getProfileImageSrc(user, true));
  }, [user]);

  useEffect(() => {
    // Registrar callback para actualizaciones globales de imagen
    const unregister = registerImageUpdateCallback(() => {
      updateImage();
    });

    return unregister;
  }, [updateImage]);

  useEffect(() => {
    // Actualizar cuando cambie la imagen del usuario o sus datos
    if (user?.profileImageUrl || user?.updatedAt || user?.id) {
      updateImage();
    }
  }, [user?.profileImageUrl, user?.updatedAt, user?.id, updateImage]);

  // Generar URL de imagen solo cuando sea necesario
  useEffect(() => {
    const src = getProfileImageSrc(user, false);
    setImageSrc(src);
  }, [user, imageKey]);

  return {
    imageKey,
    imageSrc
  };
}; 